import React from 'react';
import { FaTimes } from 'react-icons/fa';

export const LinkSelectedTemplate = ({ item, onClear }) => {
  if (!item) {
    return null;
  }

  return (
    <div className='w-full mt-05 flex items-center justify-between gap-1 rounded border border-secondary border-opacity-40 bg-secondary bg-opacity-10 px-1 py-05 text-sm'>
      <div className='min-w-0'>
        <div className='text-xs uppercase text-secondary'>Template sélectionné</div>
        <div className='truncate text-contrast'>{item.label}</div>
      </div>
      <button
        type='button'
        className='shrink-0 rounded p-05 text-contrast text-opacity-70 transition hover:text-secondary'
        title='Retirer le template sélectionné'
        onClick={onClear}
      >
        <FaTimes />
      </button>
    </div>
  );
};
